const Footer = () => {
    return (
        <>
        <footer>
            <nav>
            <ul>
                <li><a href="https://news.ycombinator.com/newsguidelines.html">Guidelines</a></li>
                <li><a href="https://news.ycombinator.com/newsfaq.html">FAQ</a></li>
                <li><a href="https://news.ycombinator.com/lists">Lists</a></li>
                <li><a href="https://github.com/HackerNews/API">API</a></li>
                <li><a href="https://news.ycombinator.com/security.html">Security</a></li>
                <li><a href="http://www.ycombinator.com/legal/">Legal</a></li>
                <li><a href="http://www.ycombinator.com/apply/">Apply to YC</a></li>
                <li><a href="mailto:hn@ycombinator.com">Contact</a></li>
            </ul>
            </nav>
        </footer>
        </>
    )
}
 
export default Footer